export function equalHeight() {
  const setEqualHeight = () => {
    const elements = document.querySelectorAll('[data-equal-height]');
    const groups = Array.from(elements).reduce((acc, el) => {
      const groupName = el.dataset.equalHeight;
      if (groupName) {
        acc[groupName] = acc[groupName] || [];
        acc[groupName].push(el);
      }
      return acc;
    }, {});

    Object.values(groups).forEach(groupEls => {
      groupEls.forEach(el => el.style.height = 'auto');
      const maxHeight = Math.max(...groupEls.map(el => el.offsetHeight));
      groupEls.forEach(el => el.style.height = `${maxHeight}px`);
    });
  };

  const debounce = (func, delay = 100) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };


  setEqualHeight();
  window.addEventListener('resize', debounce(setEqualHeight, 100));
}